/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { OriginType, SanctioningBodyEnum } from 'models/viewModels';
import { createEntity } from 'jotai/entity';
import { SystemWorkspaceId, systemWorkspaceIdSlug } from 'jotai/workspace/SystemWorkspaceId';
import { WorkspaceObject } from 'jotai/workspace/WorkspaceObject';

export const mobileViewIndy: WorkspaceObject = {
  id: SystemWorkspaceId.MobileViewIndy,
  name: 'Mobile View Indy',
  slug: systemWorkspaceIdSlug.mobileViewIndy,
  owner: 'system',
  sanctioningBody: SanctioningBodyEnum.INDYCAR,
  activeView: 't0',
  views: {
    byId: {
      t0: { id: 't0', name: 'Race', visualizations: ['v0'], layouts: 'vl0' },
    },
    allIds: ['t0'],
  },
  viewLayouts: {
    byId: {
      vl0: [{ i: 'v0', x: 0, y: 0, w: 6, h: 30 }],
    },
    allIds: ['vl0'],
  },
  visualizations: {
    byId: {
      v0: { id: 'v0', name: 'Race Order Table', type: 'raceOrderTable', settings: 'vs0' },
      v1: { id: 'v1', name: 'Lap Times Table', type: 'lapTimesTable', settings: 'vs1' },
      v2: { id: 'v2', name: 'Qualifying Order Table', type: 'qualifyingOrderTable', settings: 'vs2' },
    },
    allIds: ['v0', 'v1'],
  },
  visualizationSettings: {
    byId: {
      vs0: {
        id: 'vs0',
        columnStates: [
          { colId: 'runningPosition', sort: 'asc', flex: 1 },
          { colId: 'vehicleNumber', flex: 1 },
          { colId: 'driverFullName', hide: true, flex: 1 },
          { colId: 'lapsCompleted', flex: 1 },
          { colId: 'deltaToTarget', flex: 1 },
          { colId: 'lapsLed', hide: true, flex: 1 },
          { colId: 'lastLapTime', flex: 1 },
          { colId: 'bestLapTime', flex: 1 },
          { colId: 'movingAverageLapTime', hide: true, flex: 1 },
          { colId: 'runName', flex: 1 },
          { colId: 'ppLap', hide: true, flex: 1 },
          { colId: 'ppStrat', hide: true, flex: 1 },
        ],
        localVehicleSelections: {
          useLocalSelections: true,
          selectedGroup: 'oem',
          selectedOems: ['Chevrolet'],
          selectedPerformances: [],
          selectedPlayoffTopDrivers: 'none',
          selectedPlayoffDrivers: 'none',
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
      vs1: {
        id: 'vs1',
        columnStates: [
          { colId: 'runningPosition', sort: 'asc', flex: 1 },
          { colId: 'lapsCompleted', flex: 1 },
          { colId: 'lastLapTime', flex: 1 },
          { colId: 'fastestPosition', flex: 1 },
        ],
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
      vs2: {
        id: 'vs2',
        columnStates: [
          { colId: 'runningPosition', sort: 'asc', hide: false, flex: 1 },
          { colId: 'qualifyingPosition', sort: 'asc', hide: true, flex: 1 },
          { colId: 'vehicleNumber', hide: false, flex: 1 },
          { colId: 'driverFullName', hide: true, flex: 1 },
          { colId: 'lapsCompleted', hide: true, flex: 1 },
          { colId: 'deltaToTarget', hide: true, flex: 1 },
          { colId: 'lapsLed', hide: true, flex: 1 },
          { colId: 'lastLapTime', hide: true, flex: 1 },
          { colId: 'bestLapTime', hide: false, flex: 1 },
          { colId: 'movingAverageLapTime', hide: true, flex: 1 },
          { colId: 'runName', hide: true, flex: 1 },
        ],
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.MULTILOOP,
      },
    },
    allIds: ['vs0', 'vs1', 'vs2'],
  },
  selectedCompetitorGroups: {},
  competitorGroups: createEntity(),
  competitorGroupVehicles: createEntity(),
  selectedReferenceVehicle: createEntity(),
  hideFooter: false,
  trackMapSettings: createEntity(),
};
